module.exports = __webpack_public_path__ + "static/img/mobile-img@m.5dcf1eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/mobile-img@m.png
// module id = PRfU
// module chunks = 0